'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroTooltip = require('./NitroTooltip');

var _NitroTooltip2 = _interopRequireDefault(_NitroTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroTooltip2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-tooltip/index.js
// module id = 3051
// module chunks = 4